import { baseDocSerializer } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const priceListDocSerializer = Serializers.object({
  ...baseDocSerializer("price-list").fields,
  currency: Serializers.string.nullable(),
});

export type PriceListDoc = SerializerValue<typeof priceListDocSerializer>;
